import _ from "lodash";
export default (row, rules, languages, invert) => {
  const result = {};
  const validatableFields = Object.keys(rules);
  //for each language,
  //take each validatable field's rules,
  //and find first rule violating the spec
  //and set feedback based on that rule
  //if no rule is violated, isValid is set to true for that entry
  for (let langIndex = 0; langIndex < languages.length; langIndex++) {
    const lang = languages[langIndex];
    result[lang.languageCode] = Object.fromEntries(validatableFields.map((x) => [x, {}])); //build a default object with all language key

    for (let fieldIndex = 0; fieldIndex < validatableFields.length; fieldIndex++) {
      const field = validatableFields[fieldIndex];
      const sortedRules = _.sortBy(rules[field], (x) => x.severity);

      if (row[lang.languageCode]) {
        // evaluate rules only if data for language is loaded.
        for (let ruleIndex = 0; ruleIndex < sortedRules.length; ruleIndex++) {
          const spec = sortedRules[ruleIndex];
          const context = { language: lang };
          let failed;
          if (invert) {
            failed = spec.rule(row[lang.languageCode], lang.languageCode, row, context);
          } else {
            failed = !spec.rule(row[lang.languageCode], lang.languageCode, row, context);
          }

          if (failed) {
            const msg = typeof spec.msg === "function" ? spec.msg(row[lang.languageCode], context) : spec.msg;
            result[lang.languageCode][field] = {
              isValid: false,
              feedback: msg,
              type: spec.severity
            };
            break;
          }
        }
      }
      if (!result[lang.languageCode][field]) {
        result[lang.languageCode][field] = {
          isValid: true,
          feedback: "",
          type: ""
        };
      }
    }
  }

  return result;
};
